import { useEffect, useState } from "react";

const ZONES = [
  { city: "مكة المكرمة", tz: "Asia/Riyadh" },
  { city: "دبي", tz: "Asia/Dubai" },
  { city: "القاهرة", tz: "Africa/Cairo" },
  { city: "لندن", tz: "Europe/London" },
  { city: "نيويورك", tz: "America/New_York" },
  { city: "طوكيو", tz: "Asia/Tokyo" },
  { city: "شنغهاي", tz: "Asia/Shanghai" },
];

export function WorldClock() {
  const [now, setNow] = useState(new Date());
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(t); }, []);
  const hijri = new Intl.DateTimeFormat("ar-SA-u-ca-islamic-umalqura", { dateStyle: "full" }).format(now);

  return (
    <div className="space-y-4" data-testid="world-clock">
      <div className="panel p-5 text-center">
        <p className="font-mono text-4xl font-semibold text-cyan-300 tracking-wider" dir="ltr">{now.toLocaleTimeString("en-GB", { timeZone: "Asia/Riyadh" })}</p>
        <p className="text-sm text-slate-300 mt-2">{now.toLocaleDateString("ar-SA", { dateStyle: "full" })}</p>
        <p className="text-xs text-slate-500 mt-1">{hijri}</p>
      </div>
      <div className="space-y-2">
        {ZONES.map((z) => {
          const h = Number(new Intl.DateTimeFormat("en-GB", { hour: "numeric", hour12: false, timeZone: z.tz }).format(now));
          const day = h >= 6 && h < 18;
          return (
            <div key={z.tz} className="flex items-center justify-between rounded-xl bg-white/[0.03] border border-white/[0.05] px-4 py-2.5" data-testid={`clock-zone-${z.tz.split("/")[1]}`}>
              <div className="flex items-center gap-2">
                <span className={`h-2 w-2 rounded-full ${day ? "bg-amber-300" : "bg-indigo-400"}`} />
                <span className="text-sm text-slate-200">{z.city}</span>
              </div>
              <span className="font-mono text-sm text-slate-100" dir="ltr">{now.toLocaleTimeString("en-GB", { timeZone: z.tz, hour: "2-digit", minute: "2-digit" })}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
